import React, { useEffect, useState } from 'react';
import { getAdditionalOffersData } from 'src/components/organisms/NewOffersSlider/hooks/useOffersData';
import styles from './Card.scss';
import { Offer } from 'src/components/organisms/NewOffersSlider/types';
import { useDispatch } from 'react-redux';
import { showAuth } from 'src/redux/modules/common/authModal/actions';
import LoadingDots from '@ott/loading-dots';
import Tooltip from '@ott/tooltip';
import copyToClipboard from 'src/utility/copyToClipboard/copyToClipboard';
import metrics from 'utility/metrics';

const enum TooltipLabel {
  PromoCodeCopied = 'Промокод скопирован',
  LinkCopied = 'Ссылка скопирована',
  CantCopy = 'Не удалось скопировать',
}

const metricsClick = ({id, name}: {id: string, name: string}) => {
  const metricsData = {offer_id: id, offer_name: name}
  metrics('main_offers_click', metricsData);
}

export const CopyButton = ({ cardData, locator }: { cardData: Offer, locator: string }) => {
  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState('');
  const [tooltip, setTooltip] = useState<TooltipLabel>(TooltipLabel.PromoCodeCopied);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const handleClick = async () => {
    metricsClick({id: cardData.id, name: cardData.name})
    /*
      В том случае, когда пользователь уже нажал на кнопку, у нас уже был отправлен запрос на получение данных.
      Нам нет смысла запрашивать данные еще раз, поэтому просто показываем тултип о том что скопировано.
    */
    if (label && label !== cardData.buttonText) {
      copyToClipboard(label);
      setTooltipOpen(true);
      return null;
    }

    setLoading(true);
    const data = await getAdditionalOffersData({ id: cardData.id });
    if (data?.promo) {
      setLabel(data.promo);
      setTooltip(TooltipLabel.PromoCodeCopied);
      copyToClipboard(data.promo);
    } else if (data?.buttonLink) {
      setTooltip(TooltipLabel.LinkCopied);
      copyToClipboard(data.buttonLink);
    } else {
      setTooltip(TooltipLabel.CantCopy);
    }
    setLoading(false);
    setTooltipOpen(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTooltipOpen(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [tooltipOpen]);

  return (
    <Tooltip content={tooltip} isVisible={tooltipOpen}>
      <button className={styles.cardButton} onClick={handleClick} data-locator={locator}>
        {loading ? <LoadingDots isWhite={true} /> : label || cardData.buttonText}
      </button>
    </Tooltip>
  );
};

export const LinkButton = ({ cardData, locator }: { cardData: Offer, locator: string }) => {
  const handleClick = () => metricsClick({id: cardData.id, name: cardData.name})
return (
  <a className={styles.cardButton} href={cardData.buttonLink} onClick={handleClick} target="_blank" data-locator={locator}>
    {cardData.buttonText}
  </a>
);
}

export const AuthButton = ({ cardData, locator }: { cardData: Offer, locator: string }) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    metricsClick({id: cardData.id, name: cardData.name})
    dispatch(showAuth())
  }

  return (
    <button className={styles.cardButton} onClick={handleClick} data-locator={locator}>
      {cardData.buttonText}
    </button>
  );
};
